import { render, staticRenderFns } from "./DistributorRevenue.vue?vue&type=template&id=4fc04b18&"
import script from "./DistributorRevenue.vue?vue&type=script&lang=js&"
export * from "./DistributorRevenue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports